module.exports = __webpack_public_path__ + "img/Spoon-fork-knife-icon.f053d67c.png";